import React, {useCallback} from 'react'
import {useSelector} from 'react-redux'
import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {Home} from 'components/Home'
import {SplashScreenRemover} from 'components/SplashScreenRemover'
import TrackPageView from 'components/TrackPageView'
import {useConditionalEffect} from 'hooks/useConditionalEffect'
import {useSyncHomePageSearchBox} from 'hooks/useSyncHomePageSearchBox'
import {useSyncStoreWithUrl} from 'hooks/useSyncStoreWithUrl'
import {getSapiMetaOptions} from 'modules/meta/selectors'
import {SapiProvider} from 'modules/sapiSearch/SapiProvider'

import InjectPageDataId from '@daedalus/core/src/analytics/components/InjectPageDataId'
import {Page} from '@daedalus/core/src/analytics/types/Events'
import {getDataFile} from '@daedalus/core/src/experiments/modules/selectors'
import {collectSapiVariationsParam} from '@daedalus/core/src/experiments/sapi'
import {ProfileKey} from '@findhotel/sapi/dist/types/packages/core/src'

const HomeView = () => {
  const {isMobile} = useDeviceLayout()

  useSyncStoreWithUrl()
  useSyncHomePageSearchBox()
  const sapiMetaOptions = useSelector(getSapiMetaOptions)
  const dataFile = useSelector(getDataFile)
  const variations = collectSapiVariationsParam(
    dataFile?.featureFlags.map(({key}) => key)
  )
  const generateOptions = useCallback(
    () => ({
      ...sapiMetaOptions,
      variations
    }),
    [sapiMetaOptions]
  )

  useConditionalEffect(
    async () =>
      import(
        /* webpackChunkName: "AccommodationOverlayContent" */
        /* webpackPrefetch: true */
        'components/Accommodation/HotelDetailsOverlay/Mobile/AccommodationOverlayContent/AccommodationOverlayContent'
      ),
    isMobile
  )

  return (
    <>
      <TrackPageView pageName={Page.Home} />
      <InjectPageDataId page={Page.Home} />
      <SplashScreenRemover />

      <SapiProvider
        profileKey={process.env.NEXT_PUBLIC_SAPI_PROFILE_KEY as ProfileKey}
        generateOptions={generateOptions}
      >
        <Home />
      </SapiProvider>
    </>
  )
}

export default HomeView
